import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Card } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		backgroundColor: theme.palette.background.paper,
		flex: "none",
		borderBottom: `1px solid ${theme.palette.divider}`,
		borderRadius: 0,
		minHeight: 64,
		padding: theme.spacing(0.75, 1.5, 0.75, 1),
		gap: theme.spacing(1.5),
	},
	backButtonSkeleton: {
		flex: "none",
	},
	infoBlock: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1.5),
		flex: 1,
		minWidth: 0,
	},
	actionBlock: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		flex: "none",
	},
}));

const TicketHeaderSkeleton = () => {
	const classes = useStyles();

	return (
		<Card square className={classes.ticketHeader}>
			<Skeleton
				animation="wave"
				variant="rect"
				width={40}
				height={40}
				className={classes.backButtonSkeleton}
			/>

			<div className={classes.infoBlock}>
				<Skeleton animation="wave" variant="circle" width={40} height={40} />
				<div style={{ flex: 1, minWidth: 0 }}>
					<Skeleton animation="wave" width={140} height={20} />
					<Skeleton animation="wave" width={110} height={16} />
				</div>
			</div>

			<div className={classes.actionBlock}>
				<Skeleton animation="wave" variant="circle" width={32} height={32} />
				<Skeleton animation="wave" variant="circle" width={32} height={32} />
			</div>
		</Card>
	);
};

export default TicketHeaderSkeleton;
